<template>
  <div
    class="search-input"
    :class="{ 'is-centered': centered, 'is-processing': processing }"
  >
    <form @submit.prevent="submit">
      <input
        v-model="string"
        ref="input"
        placeholder="KEYWORD"
        @input="change"
        @blur="blur"
      />
    </form>
    <div class="search-input-icon" v-if="string.length === 0">
      <i class="fal fa-search"></i>
    </div>
    <div v-if="string.length" class="search-input-clear" @click="clear">
      <i class="fal fa-times"></i>
    </div>
    <div v-if="noResults" class="search-input-noresults">No results found…</div>
  </div>
</template>

<script>
export default {
  props: {
    centered: Boolean,
    noResults: Boolean,
    processing: Boolean
  },
  data() {
    return {
      string: '',
      timeout: null
    }
  },
  methods: {
    focus() {
      this.$refs.input.focus()
    },
    change() {
      if (!this.isMobile()) {
        clearTimeout(this.timeout)

        this.timeout = setTimeout(() => {
          this.$emit('change', this.string)
        }, 400)
      }
    },
    submit() {
      this.$emit('change', this.string)
      this.$refs.input.blur()
    },
    blur() {
      setTimeout(() => {
        if (this.string) {
          this.$emit('change', this.string)
        }
      }, 100)
    },
    clear() {
      this.string = ''
      this.$emit('change', '')
      this.$refs.input.focus()
    },
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    }
  }
}
</script>
